import { DateOnly } from "../../@client/System"

export function getDateOnly(timeStamp?: string | Date) {
  const date = timeStamp ? new Date(timeStamp) : new Date()
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const day = date.getDate().toString().padStart(2, "0")
  return `${year}-${month}-${day}` as DateOnly
}
